import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestMigrationPost = {
    path: "/migration/:migration/:action",
    method: RouteHttpVerb.POST
};
export { locationRestMigrationPost };
